import { initializeApp } from 'firebase/app';
import { resolveEnvironment } from './environment';

export const blogEnvironment = resolveEnvironment(process.env);
export const app = initializeApp(blogEnvironment.firebaseConfig);
export const measurementId = blogEnvironment.firebaseConfig.measurementId;
